export const BOT_SESSION_ID = 'bot_session_id';

export const MESSAGE_TYPE_BOT = 'bot';
export const MESSAGE_TYPE_USER = 'user';
export const MESSAGE_TYPE_GREETING = 'greeting';
export const MESSAGE_TYPE_QUICK_BUTTONS = 'quick_buttons';

export const CHAT_MESSAGES = 'chatMessages';

export const FILLER_MESSAGES = [
    "Please hold on while I retrieve the information.",
    "Kindly wait a moment while I gather the necessary details.",
    "Retrieving the requested data—thank you for your patience.",
    "Allow me a moment to look into that for you.",
    "I'm currently accessing the information; this will only take a moment.",
    "Your request is being processed—please stand by.",
    "One moment while I verify the relevant details.",
    "Please bear with me while I obtain the necessary information.",
    "I am in the process of retrieving that for you.",
    "Thank you for waiting; I will have the details shortly."
];

export const TIME_STAMP_FORMAT = 'hh:mm a';
